import { clipEnd } from '../timeline/queries.ts';
import type { Project, Track } from '../model/schema.ts';

/**
 * Restores track invariants after an edit:
 *  - clips sorted by start,
 *  - transitions only between adjacent clips, at most one per cut, duration clamped to the clips.
 */
export function normalizeTrack(track: Track): void {
  track.clips.sort((a, b) => a.start - b.start);
  const byId = new Map(track.clips.map((c) => [c.id, c]));
  const seenCuts = new Set<string>();
  track.transitions = track.transitions.filter((tr) => {
    const from = byId.get(tr.fromClipId);
    const to = byId.get(tr.toClipId);
    if (!from || !to || clipEnd(from) !== to.start) return false;
    const key = `${from.id}>${to.id}`;
    if (seenCuts.has(key)) return false;
    seenCuts.add(key);
    // Each clip may give at most half of itself to each of its edges' transitions.
    const max = Math.max(1, Math.min(from.duration, to.duration));
    tr.duration = Math.min(tr.duration, max);
    return true;
  });
}

export function normalizeProject(project: Project): void {
  for (const seq of Object.values(project.sequences)) {
    for (const t of seq.videoTracks) normalizeTrack(t);
    for (const t of seq.audioTracks) normalizeTrack(t);
  }
}
